import React, { useState, useEffect, useRef, useCallback } from "react";
import logo1 from "../../../images/MAAMAAS_LOGO.png"; // Default logo
import banner from "../../../images/aaaservices/zomato.avif"; // Default banner src/images/zomato.avif
import { Link } from "react-router-dom";
import {
    FaWhatsapp,
    FaInstagram,
    FaFacebookF,
    FaYoutube,
    FaEdit, // Keep if used elsewhere, otherwise can remove
} from "react-icons/fa";

import Gorceryaboutmaamaas from "../Grocery/pages/Gorceryaboutmaamaas";
import Groceryandbeveragesadvertise from "../Grocery/pages/Groceryandbeveragesadvertise";
import GroceryBestdeals from "../Grocery/pages/GroceryBestdeals";
import GroceryGalleryCards from "../Grocery/pages/GroceryGalleryCards";
import Groceryleadershipcard from "../Grocery/pages/Groceryleadershipcard";
import Grocerymissionvisioncards from "../Grocery/pages/Grocerymissionvisioncards";

const Groceryladingpage = () => {

    const [showMore, setShowMore] = useState(false);
    const [showMoree, setShowMoree] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const scrollContainerRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    // const fileInputRef = useRef(null); // Keep if used elsewhere

    // State for modal visibility
    const [showModal, setShowModal] = useState(false);

    // State for currently displayed data (fetched or default)
    const [currentName, setCurrentName] = useState(""); // Default name
    const [currentYear, setCurrentYear] = useState(""); // Default year
    const [currentWhatsapp, setCurrentWhatsapp] = useState("");
    const [currentInstagram, setCurrentInstagram] = useState("");
    const [currentFacebook, setCurrentFacebook] = useState("");
    const [currentTwitter, setCurrentTwitter] = useState("");
    const [currentBanner, setCurrentBanner] = useState(banner); // Default banner image
    const [currentLogo, setCurrentLogo] = useState(); // Default logo image
    const [currentBannerId, setCurrentBannerId] = useState(null); // <<< State for existing Banner ID
    const [bannerFile, setBannerFile] = useState(null);
    const [logoFile, setLogoFile] = useState(null);

    // State for user ID
    const [userId, setUserId] = useState("");

    // State for form inputs within the modal
    const [name, setName] = useState("");
    const [year, setYear] = useState("");
    const [bannerBase64, setBannerBase64] = useState(null); // Use null initially
    const [logoBase64, setLogoBase64] = useState(null); // Use null initially
    const [whatsapp, setWhatsapp] = useState("");
    const [instagram, setInstagram] = useState("");
    const [facebook, setFacebook] = useState("");
    const [twitter, setTwitter] = useState("");
    const [vendorId, setVendorId] = useState(null);
    const isMobile = window.innerWidth <= 768;




    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    // --- Function to Fetch Banner Data ---
    // Wrapped in useCallback to stabilize its identity if needed as a dependency elsewhere
    const fetchBannerData = useCallback(async () => {
        const currentVendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!currentVendorId || !token) {
            setCurrentBanner(banner);
            setCurrentLogo();
            setCurrentBannerId(null);
            return;
        }

        setIsLoading(true);

        try {
            const response = await fetch(
                `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/grocery/banner/get/${currentVendorId}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) {
                setCurrentBanner(banner);
                setCurrentLogo();
                setCurrentBannerId(null);
                return;
            }

            const data = await response.json();

            // ✅ Handle image URLs directly (not base64)
            if (data.companyBanner) {
                setCurrentBanner(data.companyBanner); // URL from API
            } else {
                setCurrentBanner(banner);
            }

            if (data.companyLogo) {
                setCurrentLogo(data.companyLogo); // URL from API
            } else {
                setCurrentLogo();
            }

            setCurrentName(data.companyName || "");
            setCurrentYear(data.establishedYear || "");
            setCurrentWhatsapp(data.whatsappLink || "");
            setCurrentInstagram(data.instagramLink || "");
            setCurrentFacebook(data.facebookLink || "");
            setCurrentTwitter(data.twitterLink || "");
            setCurrentBannerId(data.bannerId || null);

        } catch (error) {
            console.error("Error fetching banner data:", error);
            setCurrentBanner(banner);
            setCurrentLogo();
            setCurrentBannerId(null);
        } finally {
            setIsLoading(false);
        }
    }, []);



    // --- Fetch banner data when component mounts or vendorId changes ---
    useEffect(() => {
        fetchBannerData();
    }, [vendorId, fetchBannerData]);


    // --- Function to handle image selection and conversion to Base64 ---
    const handleImageUpload = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        if (type === "banner") setBannerFile(file);
        if (type === "logo") setLogoFile(file);
    };



    // --- Function to Open Modal and Pre-fill Form for Editing ---
    const handleOpenModal = () => {
        if (currentBannerId) {
            // --- EDIT MODE: Pre-fill form with current data ---
            // console.log("Opening modal in EDIT mode for bannerId:", currentBannerId);
            setName(currentName);
            setYear(currentYear);
            setWhatsapp(currentWhatsapp);
            setInstagram(currentInstagram);
            setFacebook(currentFacebook);
            setTwitter(currentTwitter);
            // **Crucially reset image base64 state - user MUST re-upload for edit**
            // (Based on current validation logic requiring both images)
            setBannerBase64(null);
            setLogoBase64(null);
        } else {
            // --- ADD MODE: Clear form ---
            // console.log("Opening modal in ADD mode");
            setName("");
            setYear("");
            setWhatsapp("");
            setInstagram("");
            setFacebook("");
            setTwitter("");
            setBannerBase64(null);
            setLogoBase64(null);
        }
        setShowModal(true); // Open the modal
    };


    const handleFormSubmit = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("Session expired. Please log in again.");
            return;
        }

        if (!name || !year || (!bannerFile && !currentBannerId) || (!logoFile && !currentBannerId)) {
            alert("Please fill Company Name, Year, and upload both Banner and Logo images.");
            return;
        }

        const isEditing = !!currentBannerId;
        const url = isEditing
            ? `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/banner/update/${currentBannerId}`
            : `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/banner/${vendorId}`;

        // 🧾 Step 1: Create JSON object for non-file fields
        const bannerData = {
            companyName: name,
            establishedYear: year,
            whatsappLink: whatsapp || "",
            instagramLink: instagram || "",
            facebookLink: facebook || "",
            twitterLink: twitter || "",
        };

        // 🧩 Step 2: Create FormData — append JSON + files
        const formData = new FormData();
        formData.append("bannerData", new Blob([JSON.stringify(bannerData)], { type: "application/json" })); // JSON Part

        if (bannerFile) formData.append("companyBanner", bannerFile); // Only files go separately
        if (logoFile) formData.append("companyLogo", logoFile);

        // 🧠 Step 3: Log the sent data for debugging
        console.log("🚀 Sending banner update request...");
        console.log("🔗 URL:", url);
        console.log("🧾 JSON Data:", bannerData);
        if (bannerFile) console.log("📂 Banner File:", bannerFile.name, bannerFile.type, bannerFile.size);
        if (logoFile) console.log("📂 Logo File:", logoFile.name, logoFile.type, logoFile.size);

        try {
            const res = await fetch(url, {
                method: isEditing ? "PUT" : "POST",
                headers: {
                    Authorization: `Bearer ${token}`, // ⚠️ Don't set Content-Type manually
                },
                body: formData,
            });

            console.log("📥 Response status:", res.status);

            const contentType = res.headers.get("content-type");
            let responseBody;

            if (contentType && contentType.includes("application/json")) {
                responseBody = await res.json();
            } else {
                responseBody = await res.text();
            }

            console.log("🧾 Response Body:", responseBody);

            if (!res.ok) {
                console.error("❌ Failed to update banner:", responseBody);
                alert("Failed to update banner. Check console for details.");
                return;
            }

            console.log("✅ Banner updated successfully:", responseBody);
            alert("Banner updated successfully!");
            fetchBannerData();
            setShowModal(false);

        } catch (error) {
            console.error("🔥 Network or unexpected error:", error);
            alert("Error updating banner. Check console for details.");
        }
    };





    // --- Style for buttons below banner ---
    const buttonStyle = {
        padding: "10px 20px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "none",
        backgroundColor: "green",
        color: "white",
        cursor: "pointer",
        marginTop: "10px",
        fontWeight: "bold",
        zIndex: "0000"
    };
    const buttonStylee = {
        padding: "10px 20px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "none",
        backgroundColor: "blue",
        color: "white",
        cursor: "pointer",
        marginTop: "10px",
        fontWeight: "bold",
        zIndex: "0000"

    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div
                    style={{ marginTop: isMobile ? '0px' : '0px' }}
                    className="col-lg-12 col-md-7 col-sm-12 col-12 subscription-home "
                >
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-2"></div>
                            <div className="col-lg-8">
                                <p
                                    className="breadcrumb maamaas-home-bredcum"
                                    style={{
                                        position: "fixed",
                                        top: isMobile ? "50px" : "80px",
                                        left: isMobile ? "5px" : "235px",
                                        width: "100%",
                                        backgroundColor: "#fff",
                                        zIndex: 1000,
                                        padding: "10px 0",
                                        fontSize: isMobile ? "14px" : "18px",
                                        fontWeight: isMobile ? "normal" : "bold",
                                        textAlign: "center",
                                        margin: 0,
                                    }}
                                >
                                    <Link
                                        to="/Newmainlandingpage"
                                        style={{
                                            color: "purple",
                                            fontWeight: "bold",
                                            textDecoration: "none",
                                        }}
                                    >
                                        Home
                                    </Link>
                                    <span className="separator"> &gt; </span>
                                    <Link
                                        to="/foodladingpage"
                                        style={{
                                            color: "purple",
                                            fontWeight: "bold",
                                            textDecoration: "none",
                                        }}
                                    >
                                        Fresh & Groceries
                                    </Link>

                                    {/* <span className="separator"> &gt; </span> */}



                                </p>
                                <div
                                    style={{
                                        overflowY: "auto",
                                        scrollbarWidth: "none",
                                        maxHeight: "calc(100vh - 150px)",
                                        msOverflowStyle: "none",
                                    }}
                                    className="hide-scrollbar homeheight"
                                >
                                    {/* Banner Section */}
                                    <div style={{ position: "relative", marginBottom: "10px" }}>
                                        {isLoading && <div style={{ textAlign: 'center', padding: '50px' }}>Loading Banner...</div>}
                                        {!isLoading && (
                                            <>
                                                <div style={{ position: "relative", width: "100%", height: "450px", borderRadius: "20px", overflow: "hidden" }}>
                                                    <img
                                                        src={currentBanner || banner}
                                                        alt="Banner"
                                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                    />
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            backgroundColor: "rgba(0, 0, 0, 0.4)", // <-- adjust color and opacity here
                                                            borderRadius: "20px"
                                                        }}
                                                    />
                                                </div>
                                                {/* Logo */}
                                                <img
                                                    src={currentLogo || logo1} // Use currentLogo, fallback to default import
                                                    alt="Logo"
                                                    style={{
                                                        position: "absolute",
                                                        top: "10px", // Adjusted position
                                                        left: "-10px",
                                                        height: "120px", // Adjusted size
                                                        width: "auto", // Maintain aspect ratio
                                                        maxWidth: "160px",
                                                        zIndex: 1,
                                                        padding: '5px',
                                                        borderRadius: '8px'
                                                    }}
                                                    className="current-image"
                                                />

                                                {/* Company Name */}
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "0px",
                                                        // left: "250px", 
                                                        // right: "180px",
                                                        color: "white",
                                                        fontSize: "38px", // Adjusted size
                                                        fontWeight: "bold",
                                                        textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
                                                        zIndex: 1,
                                                        //  backgroundColor: 'rgba(0,0,0,0.3)', // Slight background
                                                        padding: '5px 10px',
                                                        borderRadius: '5px',
                                                        display: 'inline-block', // Prevent stretching full width
                                                        maxWidth: 'calc(100% - 350px)' // Prevent overlap
                                                    }}
                                                    className="current-name-data"
                                                >
                                                    {currentName}
                                                </div>

                                                {/* Established Year */}
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "50px", // Below name
                                                        // left: "440px", 
                                                        color: "white",
                                                        fontSize: "28px", // Adjusted size
                                                        fontWeight: "bold",
                                                        textShadow: "1px 1px 3px rgba(0, 0, 0, 0.7)",
                                                        zIndex: 1,

                                                        padding: '3px 8px',
                                                        borderRadius: '5px'
                                                    }}
                                                    className="since-lastyear"
                                                >
                                                    Since {currentYear}
                                                </div>

                                                {/* "Add/Edit" Button - Now uses handleOpenModal */}
                                                <button
                                                    onClick={handleOpenModal} // <<< Use the new handler
                                                    style={{
                                                        position: "absolute",
                                                        top: "20px", // Align with name/logo top
                                                        right: "20px",
                                                        color: "white",
                                                        padding: "8px 15px", // Adjusted padding
                                                        fontWeight: "bold",
                                                        background: "#b15cd6",
                                                        borderRadius: "5px",
                                                        border: "none",
                                                        zIndex: 2, // Above other elements
                                                        cursor: "pointer",
                                                        fontSize: '14px'
                                                    }}
                                                >
                                                    {currentBannerId ? "Edit Info" : "Add Info"} {/* Dynamic Text */}
                                                </button>

                                                {/* Social Icons Section */}
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        bottom: "40px", // Positioned below the banner bottom edge
                                                        left: 0,
                                                        right: 0,
                                                        display: "flex",
                                                        justifyContent: "center", // Center icons horizontally
                                                        gap: "30px", // Space between icons
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    {[
                                                        { label: "WhatsApp", icon: <FaWhatsapp size={40} />, color: "#25D366", link: currentWhatsapp },
                                                        { label: "Instagram", icon: <FaInstagram size={40} />, color: "#E4405F", link: currentInstagram },
                                                        { label: "Facebook", icon: <FaFacebookF size={40} />, color: "#1877F2", link: currentFacebook },
                                                        { label: "Twitter", icon: <FaYoutube size={40} />, color: "#FF0000", link: currentTwitter },
                                                    ].map((item, idx) => (
                                                        item.link && ( // Only display icon if link exists
                                                            <a
                                                                key={idx}
                                                                href={item.link}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                title={item.label}
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center",
                                                                    textDecoration: 'none',
                                                                    color: item.color // Use specific color
                                                                }}
                                                            >
                                                                {item.icon}
                                                                {/* Optional: Show label below icon
                                <span style={{ fontSize: "12px", marginTop: "4px", color: "#333" }}>
                                {item.label}
                                </span>
                                */}
                                                            </a>
                                                        )
                                                    ))}
                                                </div>
                                            </>
                                        )}
                                    </div> {/* End Banner Section */}

                                    {/* Buttons Below Banner (COM001, OPEN, Know More) */}


                                    <div className="responsive-button-group" style={{ marginTop: "-78px" }}>
                                        <div style={{ display: "flex", justifyContent: "center", gap: "0px", }} className="maamaas-home-buttons">
                                            <div
                                                style={{
                                                    padding: "10px 20px",
                                                    fontSize: "14px",
                                                    borderRadius: "8px",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    zIndex: "0000"
                                                }}
                                            >
                                                <p style={{ margin: 0, color: "#4caf50", fontWeight: "bold" }}>⏰ 09:00 AM</p>
                                                <p style={{ margin: 0, color: "red", fontWeight: "bold" }}>⏰ 10:00 PM</p>
                                            </div>
                                        </div>
                                        <button style={buttonStyle} onClick={() => setShowMore(!showMore)}>
                                            {showMore ? "Show Less" : "Know More"}
                                        </button>
                                        <button style={buttonStylee} onClick={() => setShowMoree(!showMoree)}>
                                            {showMoree ? "Hide Gallery" : "View Gallery"}
                                        </button>
                                    </div>
                                    {showMore && (
                                        <div>
                                            <Gorceryaboutmaamaas />
                                            <Grocerymissionvisioncards />
                                            <Groceryleadershipcard />


                                        </div>
                                    )}
                                    {showMoree && (
                                        <div>
                                            <GroceryGalleryCards />
                                        </div>
                                    )}

                                    {/* Always Rendered Sections */}
                                    <div className="gallery-cards-data">
                                        <GroceryBestdeals />
                                    </div>

                                    {/* --- Modal for Adding/Editing Details --- */}
                                    {showModal && (
                                        <div
                                            style={{ /* Modal Overlay Styles */
                                                position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                                                backgroundColor: "rgba(0,0,0,0.6)", display: "flex",
                                                justifyContent: "center", alignItems: "center", zIndex: 1050, // High z-index
                                                padding: '20px' // Padding for smaller screens
                                            }}
                                        >
                                            <div
                                                style={{ /* Modal Content Styles */
                                                    backgroundColor: "white", padding: "25px", borderRadius: "10px",
                                                    width: "90%", maxWidth: "450px", // Responsive width
                                                    maxHeight: '90vh', overflowY: 'auto', // Scrollable content
                                                    textAlign: "center", position: 'relative', // For close button positioning
                                                    boxShadow: '0 5px 15px rgba(0,0,0,0.3)'
                                                }}
                                            >
                                                {/* Modal Header */}
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: "15px", borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                                                    <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                                                        {currentBannerId ? "Update Banner Details" : "Upload Banner Details"} {/* Dynamic Title */}
                                                    </span>
                                                    <span onClick={() => setShowModal(false)} style={{ fontSize: "24px", cursor: "pointer", color: '#888', lineHeight: '1' }}>
                                                        × {/* Nicer close icon */}
                                                    </span>
                                                </div>

                                                {/* User ID (Read Only) - Important Context */}
                                                <input
                                                    type="text"
                                                    value={`vendor ID: ${vendorId}`} // Display clearly
                                                    readOnly
                                                    style={{ padding: "8px", fontSize: "14px", marginBottom: "15px", width: "100%", borderRadius: "4px", border: "1px solid #ccc", backgroundColor: '#f0f0f0', color: '#555' }}
                                                />

                                                {/* Form Inputs */}
                                                <input type="text" placeholder="Enter Company Name *" value={name} onChange={(e) => setName(e.target.value)} style={{ margin: "10px 0", padding: "10px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }} />
                                                <input type="number" placeholder="Enter Establishment Year *" value={year} onChange={(e) => setYear(e.target.value)} style={{ margin: "10px 0", padding: "10px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }} />

                                                {/* Banner Image Upload */}
                                                <label style={{ textAlign: "left", display: "block", marginTop: "15px", marginBottom: '5px', fontWeight: 'bold', fontSize: '14px' }}>
                                                    Banner Image * {currentBannerId ? "(Re-upload required)" : ""}
                                                </label>
                                                <input type="file" accept="image/*" onChange={(e) => handleImageUpload(e, "banner")} style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }} />
                                                {/* Optional Preview */}
                                                {/* {bannerBase64 && <img src={`data:image/jpeg;base64,${bannerBase64}`} alt="Banner Preview" width="100" style={{marginTop: '5px'}}/>} */}


                                                {/* Logo Image Upload */}
                                                <label style={{ textAlign: "left", display: "block", marginTop: "15px", marginBottom: '5px', fontWeight: 'bold', fontSize: '14px' }}>
                                                    Logo Image * {currentBannerId ? "(Re-upload required)" : ""}
                                                </label>
                                                <input type="file" accept="image/*" onChange={(e) => handleImageUpload(e, "logo")} style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }} />
                                                {/* Optional Preview */}
                                                {/* {logoBase64 && <img src={`data:image/png;base64,${logoBase64}`} alt="Logo Preview" width="60" style={{marginTop: '5px'}} />} */}


                                                {/* Social Links Section */}
                                                <div style={{ marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '15px' }}>
                                                    <p style={{ textAlign: 'left', fontSize: '14px', color: '#555', marginBottom: '15px' }}>Social Media Links (Optional):</p>
                                                    {[
                                                        { label: "WhatsApp", icon: <FaWhatsapp size={25} color="#25D366" />, value: whatsapp, setter: setWhatsapp },
                                                        { label: "Instagram", icon: <FaInstagram size={25} color="#E4405F" />, value: instagram, setter: setInstagram },
                                                        { label: "Facebook", icon: <FaFacebookF size={25} color="#1877F2" />, value: facebook, setter: setFacebook },
                                                        { label: "Twitter", icon: <FaYoutube size={25} color="#1DA1F2" />, value: twitter, setter: setTwitter },
                                                    ].map((field, idx) => (
                                                        <div key={idx} style={{ margin: "10px 0" }}>
                                                            <div style={{ display: "flex", alignItems: "center", gap: '10px' }}>
                                                                <div style={{ width: "30px", textAlign: "center" }}>{field.icon}</div>
                                                                <input
                                                                    type="text"
                                                                    placeholder={`${field.label} Link`}
                                                                    value={field.value}
                                                                    onChange={(e) => field.setter(e.target.value)}
                                                                    style={{ flex: 1, padding: "10px", borderRadius: '4px', border: '1px solid #ccc' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>

                                                {/* Submit / Update Button */}
                                                <button
                                                    onClick={handleFormSubmit}
                                                    disabled={isLoading} // Disable button while submitting
                                                    style={{
                                                        backgroundColor: isLoading ? '#ccc' : "#4CAF50", // Indicate loading state
                                                        color: "white",
                                                        padding: "12px 20px",
                                                        border: "none",
                                                        borderRadius: "5px",
                                                        cursor: isLoading ? 'not-allowed' : 'pointer',
                                                        width: "100%",
                                                        marginTop: "25px",
                                                        fontSize: '16px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    {isLoading ? 'Submitting...' : (currentBannerId ? "Update All Details" : "Submit")} {/* Dynamic Button Text */}
                                                </button>
                                                <p style={{ fontSize: '12px', color: '#888', marginTop: '10px' }}>* Required fields</p>
                                            </div>
                                        </div>
                                    )} {/* End Modal */}

                                </div> {/* End Main Content Scrollable Area */}
                            </div> {/* End col-lg-7 */}
                            <div className="col-lg-2"></div>
                        </div>

                    </div>
                </div>
                {/* Right Sidebar Section */}
                <div className="col-lg-3">
                    <Groceryandbeveragesadvertise />
                </div>
            </div>
        </div>
    );
};

export default Groceryladingpage;